<template>
  <div>
    <PageAllow controller="Settings" action="businessSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("hfPaySetting.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("hfPaySetting.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("hfPaySetting.application_title") }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("hfPaySetting.hfpay_sub_account_cust_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('hfPaySetting.hfpay_sub_account_cust_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.hfpay_sub_account_cust_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(
                            serverErrors,
                            'hfpay_sub_account_cust_id'
                          )
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("hfPaySetting.hfpay_sub_account_acct_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('hfPaySetting.hfpay_sub_account_acct_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.hfpay_sub_account_acct_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(
                            serverErrors,
                            'hfpay_sub_account_acct_id'
                          )
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("hfPaySetting.hfpay_cash_fee_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.hfpay_cash_fee_enable">
                    <v-radio
                      :label="$t('hfPaySetting.off')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('hfPaySetting.on')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("hfPaySetting.hfpay_sub_account_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group
                    row
                    v-model="settings.hfpay_sub_account_enable"
                  >
                    <v-radio
                      :label="$t('hfPaySetting.off')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('hfPaySetting.on')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("hfPaySetting.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Setting from "@/api/settings";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.split"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-type",
      },
      {
        text: i18n.t("SettingNav.splitInterface"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-setting-port",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getHfPayFromAPI();
  },

  methods: {
    getHfPayFromAPI() {
      Setting.settings(
        "keys[]=hfpay_sub_account_cust_id&keys[]=hfpay_sub_account_acct_id&keys[]=hfpay_cash_fee_enable&keys[]=hfpay_sub_account_enable"
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if(this.settings.hfpay_cash_fee_enable == null){
               this.settings.hfpay_cash_fee_enable = 0
            }
            if(this.settings.hfpay_sub_account_enable == null){
               this.settings.hfpay_sub_account_enable = 0
            }
          }
        }.bind(this)
      );
    },

    save() {
      delete this.settings.distribution_district_unique_enable;
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            const arr = [];
            for (let key in this.settings) {
              arr.push({ setting_key: key, setting_value: this.settings[key] });
            }
            Setting.batchSave(arr).then(
              function (response) {
                if (response.data.status.isOK()) {
                  // this.getHfPayFromAPI()
                  this.$router.replace(
                    "/settings/sub-account-settings/sub-account-setting-port"
                  );
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>